import _MapCache_default from "./_MapCache.js";
import _setCacheAdd_default from "./_setCacheAdd.js";
import _setCacheHas_default from "./_setCacheHas.js";

//#region ../../node_modules/lodash-es/_SetCache.js
/**
*
* Creates an array cache object to store unique values.
*
* @private
* @constructor
* @param {Array} [values] The values to cache.
*/
function SetCache(values) {
	var index = -1, length = values == null ? 0 : values.length;
	this.__data__ = new _MapCache_default();
	while (++index < length) this.add(values[index]);
}
SetCache.prototype.add = SetCache.prototype.push = _setCacheAdd_default;
SetCache.prototype.has = _setCacheHas_default;
var _SetCache_default = SetCache;

//#endregion
export { _SetCache_default as default };
//# sourceMappingURL=_SetCache.js.map